import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'role', en);

const UpdateRoleConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Manage Permissions',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.ROLE,
  permission: PERMISSION.UPDATE,
  routes: [
    {
      path: '/role/:id',
      component: React.lazy(() => import('./UpdateRole')),
    },
  ],
};

export default UpdateRoleConfig;
